<template>
  <v-container>
    <PageHeader />

    <v-form ref="form" style="width: 100%">
      <v-card>
        <Subheader v-model="search" title="Continuous Data Importers" search="Continuous Data Importers">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn color="success" dark v-on="on">
                <v-icon>add</v-icon>{{ $t('Button.Add') }}
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="clickAdd(IMPORTER_TYPE_GOES)">
                <v-list-tile-title>{{IMPORTER_TYPE_GOES}}</v-list-tile-title>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="clickAdd(IMPORTER_TYPE_JDS)">
                <v-list-tile-title>{{IMPORTER_TYPE_JDS}}</v-list-tile-title>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="clickAdd(IMPORTER_TYPE_Optimum)">
                <v-list-tile-title>{{IMPORTER_TYPE_Optimum}}</v-list-tile-title>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile @click="clickAdd(IMPORTER_TYPE_SIMPLE_SUTRON)">
                <v-list-tile-title>{{IMPORTER_TYPE_SIMPLE_SUTRON}}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </Subheader>
        <v-progress-linear class="ma-0" color="secondary" indeterminate v-if="!TimeSeriesReady" />
        <v-card-text>
          <v-data-table :headers="headers" :items="ImporterConfigs" :pagination.sync="pagination" :search="search">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.Id }}</td>
              <td>{{ props.item.Name }}</td>
              <td class="text-xs-center">{{ props.item.ImporterType }}</td>
              <td class="text-xs-right">
                <v-btn color="warning" small @click="clickUpdate(props.item.ImporterType, props.item.Id)">
                  <v-icon class="mr-1">edit</v-icon>{{ $t('Button.Edit') }}
                </v-btn>
                <v-btn color="delete" dark small @click="clickDelete(props.item.Id,props.item.Name)">
                  <v-icon class="mr-1">delete_forever</v-icon>{{ $t('Button.Delete') }}
                </v-btn>
                <v-btn color="info" small @click="clickLogs(props.item.Id,props.item.Name)">
                  <v-icon>menu_book</v-icon>{{ $t('Button.Logs') }}
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-form>

    <app-modal v-model="dialog" max-width="800">
      <template v-slot:title>{{ deleteDialogTitle }}</template>
      <template v-slot:text>{{ deleteDialogText }}</template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="delete" dark @click="agreeDelete()">
          <v-icon>delete_forever</v-icon>Delete
        </v-btn>
        <v-btn color="secondary" @click="dialog = false" outline>Cancel</v-btn>
      </template>
    </app-modal>

    <app-confirmation-modal v-model="saveFailed" max-width="500">
      <template slot="title">
        Failed
      </template>
      <template slot="text">
        {{ errorMessage }}
      </template>
      <template slot="actions">
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="saveFailed = false" outline>Cancel</v-btn>
      </template>
    </app-confirmation-modal>

    <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
      {{ snackMessage }}
      <v-btn dark flat @click.native.stop.prevent="snackbar = false">{{ $t('Button.Close') }}</v-btn>
    </v-snackbar>

    <GoesImporter v-if="showGOES" v-model="showGOES" @close="close" :importerId="importerId" @saveSuccess="saveSuccess" />
    <JdsImporter v-if="showJDS" v-model="showJDS" @close="close" :importerId="importerId" @saveSuccess="saveSuccess" />
    <OptimumImporter v-if="showOptimum" v-model="showOptimum" @close="close" :importerId="importerId" @saveSuccess="saveSuccess" />
    <SimpleSutronImporter v-if="showSIMPLE_SUTRON" v-model="showSIMPLE_SUTRON" @close="close" :importerId="importerId" @saveSuccess="saveSuccess" />
    <ImportsLogs v-if="showLogs" v-model="showLogs" :importerId="importerId" :importerName="importerName" />

  </v-container>
</template>

<script>
  import PageHeader from '@/components/generic/PageHeader'
  import Subheader from '@/components/generic/Subheader'
  import AppModal from '@/components/generic/AppModal'
  import AppConfirmationModal from '@/components/generic/AppConfirmationModal'
  import SnackBarUtil from '@/components/mixins/SnackBarUtil'
  import GoesImporter from '@/components/Administration/ContinuousDataImportModal/GoesImporter'
  import JdsImporter from '@/components/Administration/ContinuousDataImportModal/JdsImporter'
  import OptimumImporter from '@/components/Administration/ContinuousDataImportModal/OptimumImporter'
  import SimpleSutronImporter from '@/components/Administration/ContinuousDataImportModal/SimpleSutronImporter'
  import ImportsLogs from '@/components/Administration/ContinuousDataImportModal/ImportsLogs'
  import { createNamespacedHelpers } from 'vuex'
  const continuousimporterconfig = createNamespacedHelpers('continuousimporterconfig')

  export default {
    components: {
      'app-modal': AppModal,
      'app-confirmation-modal': AppConfirmationModal,
      PageHeader,
      Subheader,
      GoesImporter,
      JdsImporter,
      OptimumImporter,
      SimpleSutronImporter,
      ImportsLogs,
    },
    mixins: [SnackBarUtil],
    data() {
      return {
        ready: false,
        search: '',
        pagination: {
          rowsPerPage: 20,
          sortBy: 'TenantName',
        },
        headers: [{
          align: 'left',
          text: 'Id',
          value: 'Id',
        },
        {
          align: 'left',
          text: 'Name',
          value: 'Name',
        },
        {
          align: 'center',
          text: 'Importer Type',
          value: 'ImporterType',
        },
        {
          sortable: false,
          text: '',
          value: '',
        },
        ],
        saveFailed: false,
        errorMessage: '',
        dialog: false,
        deleteDialogTitle: '',
        deleteDialogText: '',
        showLogs: false,
        importerId: 0,
        importerName: '',
        deleteId: null,
        deleteName: '',
        showFORT_HILL: false,
        showGOES: false,
        showSIMPLE_SUTRON: false,
        showOptimum: false,
        showJDS: false,
      }
    },
    computed: {
      ...continuousimporterconfig.mapGetters(['TimeSeriesReady', 'IMPORTER_TYPE_GOES', 'IMPORTER_TYPE_SIMPLE_SUTRON', 'IMPORTER_TYPE_JDS', 'IMPORTER_TYPE_Optimum',
        'TimeSeries', 'Stations', 'ImporterConfigs',
      ]),
    },
    methods: {
      ...continuousimporterconfig.mapActions(['getContinuousStations', 'getContinuousTimeSeries', 'getImporterList', 'delteImporterConfig']),
      clickAdd(type) {
        switch (type) {
        case this.IMPORTER_TYPE_GOES:
          this.showGOES = true
          break
        case this.IMPORTER_TYPE_SIMPLE_SUTRON:
          this.showSIMPLE_SUTRON = true
          break
        case this.IMPORTER_TYPE_JDS:
          this.showJDS = true
          break
        case this.IMPORTER_TYPE_Optimum:
          this.showOptimum = true
          break
        }
      },
      clickUpdate(type, importerId) {
        switch (type) {
        case this.IMPORTER_TYPE_GOES:
          this.showGOES = true
          break
        case this.IMPORTER_TYPE_SIMPLE_SUTRON:
          this.showSIMPLE_SUTRON = true
          break
        case this.IMPORTER_TYPE_JDS:
          this.showJDS = true
          break
        case this.IMPORTER_TYPE_Optimum:
          this.showOptimum = true
          break
        }
        this.importerId = importerId
      },
      clickLogs(importerId, importerName) {
        this.showLogs = true
        this.importerId = importerId
        this.importerName = importerName
      },
      clickDelete(Id, Name) {
        this.dialog = true
        this.deleteId = Id
        this.deleteName = Name
        this.deleteDialogTitle = 'Importer Configuration Delete Confirmation'
        this.deleteDialogText = `Are you sure you want to delete importer configuration ${Name}? If deleted, the configuration will not be recoverable.`
      },
      async agreeDelete() {
        let options = this.deleteId
        await this.delteImporterConfig(options)
          .then(() => {
            this.dialog = false
            this.deleteId = null
            this.snackMessage = this.$t('SaveUpdateDeleteMsg.DeleteMsg', { msg: this.deleteName })
            this.snackColor = 'success'
            this.snackbar = true
            this.deleteName = ''
          })
          .catch((error) => {
            console.error(error)
            this.dialog = false
            this.deleteId = null
            this.deleteName = ''
            this.saveFailed = true
            this.errorMessage = error
          })
      },
      saveSuccess(data) {
        this.snackMessage = data.snackMessage
        this.snackColor = data.snackColor
        this.snackbar = data.snackbar
      },
      close() {
        this.showFORT_HILL = false,
          this.showGOES = false,
          this.showSIMPLE_SUTRON = false,
          this.showOptimum = false,
          this.showJDS = false,
          this.importerId = 0
      },
    },
    async mounted() {
      if (!this.Stations || !this.Stations.length) {
        this.getContinuousStations()
      }
      if (!this.TimeSeries || !this.TimeSeries.length) {
        this.getContinuousTimeSeries()
      }
      if (!this.ImporterConfigs || !this.ImporterConfigs.length) {
        this.getImporterList()
      }
      this.ready = true
    },
  }
</script>